import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

import constants from '../lib/constants';
import api from '../utils/api';
import '../Standings/Standings.css';

// The next draft is the one after the season in progress.
const NEXT_DRAFT_YEAR = constants.currentSeason + 1;
const PICKS_SHOWN = 12;

/**
 * Round 1 of the next draft: the manager on the clock for each pick (showing
 * the new owner for traded picks) and, once the draft pool exists, the best
 * available player by Yahoo rank for that slot. Before the pool exists the
 * player column shows a dash; nothing here errors the home page.
 */
const DraftCard = ({ outgoingPicks }) => {
    const [order, updateOrder] = useState(null);
    const [isProjected, updateIsProjected] = useState(true);
    const [available, updateAvailable] = useState([]);

    useEffect(() => {
        api.get(`/api/v1/draft/${NEXT_DRAFT_YEAR}/order`)
            .then(({ data }) => {
                updateOrder(data.order);
                updateIsProjected(data.isProjected);
            })
            .catch(() => updateOrder(null));
        // Fails until the draft table for that year exists: no projections yet.
        api.get(`/api/v1/draft/${NEXT_DRAFT_YEAR}/available`)
            .then(({ data }) => updateAvailable(Array.isArray(data) ? data : []))
            .catch(() => updateAvailable([]));
    }, []);

    if (!order) {
        return null;
    }

    const picks = order.slice(0, PICKS_SHOWN).map((manager, i) => {
        const traded = outgoingPicks && outgoingPicks[manager] && outgoingPicks[manager][NEXT_DRAFT_YEAR]
            ? outgoingPicks[manager][NEXT_DRAFT_YEAR][1]
            : null;
        return { pick: i + 1, manager, traded, player: available[i] };
    });

    return (
        <div className="home-card">
            <div className="d-flex justify-content-between align-items-baseline mb-2">
                <h5 className="mb-0">{NEXT_DRAFT_YEAR} Draft - Round 1</h5>
                {isProjected && <span className="text-light opacity-75 small">Projected order</span>}
            </div>
            <div className="table-responsive">
                <table className="table table-sm table-dark table-striped standings-table align-middle mb-2">
                    <thead>
                        <tr>
                            <th>Pick</th>
                            <th>Manager</th>
                            <th>Projected player</th>
                        </tr>
                    </thead>
                    <tbody>
                        {picks.map(({ pick, manager, traded, player }) => (
                            <tr key={pick}>
                                <td>1.{pick}</td>
                                <td>
                                    {manager}
                                    {traded && <strong> ({traded})</strong>}
                                </td>
                                <td>
                                    {player
                                        ? <>{player.name} <span className="text-light opacity-75 small">{player.posname}</span></>
                                        : '—'}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <NavLink to="/draft" className="small">
                Full draft page <i className="bi bi-chevron-right"></i>
            </NavLink>
        </div>
    );
};

export default DraftCard;
